<template>
  <!-- <div class="login-wrapper border border-light">
    <form class="form-signin" >
      <h2 class="form-signin-heading">Please sign in</h2>
      <label for="inputEmail" class="sr-only">Username</label>
      <input v-model="username"  class="form-control" placeholder="username" required autofocus>
      <label for="inputPassword" class="sr-only">Password</label>
      <input v-model="password" type="password" class="form-control" placeholder="Password" required>
      <button class="btn btn-lg btn-primary btn-block" @click="login()">Sign in</button>
    </form>
  </div> -->

      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <!-- <img src="/static/m.png" alt="VEGE" width="120" height="120"> -->
                  <!-- <h1 class="flex my-4 primary--text">MahSing Enterprise</h1> -->
                  <h1 class="flex my-4 primary--text">Yofu Veg Trading</h1>
                </div>                
                
                  <v-text-field append-icon="person" label="Login"  v-model="username" ></v-text-field>
                  <v-text-field append-icon="lock"  label="Password"  type="password" v-model="password"></v-text-field>
                
              </v-card-text>
              <v-card-actions>
              
                <v-spacer></v-spacer>
                <v-btn block color="primary" @click="login()" :loading="loading">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="3000">
      {{response_detail}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
      </v-container>
      
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      baseUrl:baseUrl,
      loading:false,
      snackbar_response:false,
      response_detail:'',

    }
  },
  methods: {

    login() {
       this.loading=true;
       const params = new URLSearchParams();
        params.append("username", this.username);
        params.append("password", this.password);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/user/registration.php",
          data: params
        })
          .then(response => {
            if (response.data.status == '1') {
              this.$session.start();
              this.$session.set('admin', response.data.admin_id);
              this.$router.push('/');
              this.$emit("update", "gg");
              
              console.log("logic success");
               this.lodaing=false;
             

            } else if (response.data.status == '2') {
               console.log(false);
               this.loading=false;
                this.snackbar_response=true;
               this.response_detail="invalid";
            
            }
          })
          .catch(error => {
            console.log(error);
            this.snackbar = true;
               this.loading=false;

          });
         
    }
  }
}
</script>

<style lang="css">

</style>